import type { PaymentCurrency } from './payments';

export const SubscriptionPeriodStatuses = {
  PLANNED: 'planned',
  PAID: 'paid',
  PAUSED: 'paused',
} as const;

export type SubscriptionPeriodStatus =
  (typeof SubscriptionPeriodStatuses)[keyof typeof SubscriptionPeriodStatuses];

export type SubscriptionPeriodPayment = {
  id: string;
  createdAt: string;
  provider: string;
  providerId: string;
  status: string;
  amount: number;
  amountRefunded: number;
  completedAt: string | null;
  currency: PaymentCurrency;
};

export type SubscriptionPeriod = {
  id: string;
  startAt: string;
  endAt: string;
  /** Null on rows created before cycles were stamped on periods. */
  cycle: number | null;
  /** Null on rows created before the status backfill. */
  status: SubscriptionPeriodStatus | null;
  createdAt: string;
  paymentSessionId: string | null;
  /** Latest payment on the period's payment session; null for planned/unpaid periods. */
  payment: SubscriptionPeriodPayment | null;
};

export type SubscriptionEvent = {
  id: string;
  createdAt: string;
  action: string;
  reason: string;
  internalUserEmail: string | null;
};

export type SubscriptionDetails = {
  subscriptionId: string;
  periods: SubscriptionPeriod[];
  events: SubscriptionEvent[];
};
